export const bankFrag = `
    code
    name
    swiftBicCode
`;
